<header>
  <div id="left-side">
    <img src="assets/icons/covid.svg" alt="Ilustração de um vírus">
    <h1>Dashboard - Mundo</h1>
  </div>
  <div id="right-side">
    <button *ngIf="!currentUrl" routerLink="/world" class="btn btn-inverted">Voltar para o início</button>
    <button routerLink="/brazil" class="btn">Ver os dados do Brasil</button>
  </div>
</header>
